import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './auth/login/login.component';
import { HomeComponent } from './home/home/home.component';
import { FurnitureComponent } from './furniture/furniture/furniture.component';
import { CustomerTableViewComponent } from 'src/app/customer/customer-table-view/customer-table-view.component';
import { UserTableViewComponent } from 'src/app/user/user-table-view/user-table-view.component';
import { ProjectTableViewComponent } from './project/project-table-view/project-table-view.component';
import { ManufacturerTableViewComponent } from './manufacturer/manufacturer-table-view/manufacturer-table-view.component';
import { AuthGuard } from './guards/auth.guard';
import { RoleGuard } from './guards/role.guard';
import { UploadComponent } from './upload/upload/upload.component';

const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: '',
    component: UploadComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'furniture',
    component: FurnitureComponent,
    canActivate: [AuthGuard, RoleGuard],
  },
  {
    path: 'manufacturer',
    component: ManufacturerTableViewComponent,
    canActivate: [AuthGuard, RoleGuard],
  },
  {
    path: 'customer',
    component: CustomerTableViewComponent,
    canActivate: [AuthGuard, RoleGuard],
  },
  {
    path: 'project',
    component: ProjectTableViewComponent,
    canActivate: [AuthGuard, RoleGuard],
  },
  {
    path: 'user',
    component: UserTableViewComponent,
    canActivate: [AuthGuard, RoleGuard],
  },
  {
    path: 'upload',
    component: UploadComponent,
    canActivate: [AuthGuard],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
